import { ArchetypeDefinition } from '../../archetypeTypes';

export const ROLE_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'herald',
        name: 'Herald',
        description: 'Signals change; elevates sensitivity to emerging patterns.',
        category: 'Roles',
        tags: ['announcement', 'signal', 'threshold'],
        weights: { waveIntensity: 0.3, linguisticComplexity: 0.25, stability: 0.15, fractalDimension: 0.3 }
    },
    {
        key: 'threshold_guardian',
        name: 'Threshold Guardian',
        description: 'Tests readiness at boundaries; filters chaotic passage.',
        category: 'Roles',
        tags: ['gate', 'test', 'boundary'],
        weights: { stability: 0.35, edgeCount: 0.3, waveIntensity: 0.2, nodeCount: 0.15 }
    },
    {
        key: 'sidekick',
        name: 'Sidekick',
        description: 'Loyal support amplifying connectivity and resilience.',
        category: 'Roles',
        tags: ['support', 'amplify', 'resilience'],
        weights: { edgeCount: 0.35, nodeCount: 0.25, stability: 0.25, averageNodeEnergy: 0.15 }
    },
    {
        key: 'shapeshifter',
        name: 'Shapeshifter',
        description: 'Ambiguity and transformation across states and roles.',
        category: 'Roles',
        tags: ['ambiguity', 'change', 'adaptation'],
        weights: { fractalDimension: 0.35, waveIntensity: 0.25, linguisticComplexity: 0.2, stability: 0.2 }
    }
];


